<template>
    <div class="page-slot text-center">  
      <iframe
        v-if="load && !error"
        :src="url"
        class="frame"
      />
      <div v-if="!load" style="background: rgba(0, 0, 0, .4); height: 100%;">
        <b-spinner
         v-if="!error"
          variant="secondary" 
          style="width: 6rem; height: 6rem; border-width: thick; margin-top: calc(50% - 8rem);"
          label="Loading"></b-spinner>
        <h4 v-else style="padding-top: calc(50% - 5rem);">{{$t('messages.errors.general')}}</h4>
      </div>
    </div>
  </template>
  
  <script>
  import layoutMixin from "@/mixins/layoutMixin";
  import { BFormInput, BFormGroup, BButton } from "bootstrap-vue";
  import Ripple from "vue-ripple-directive";
  import store from "@/store";
  
  export default {
    mixins: [layoutMixin],
    components: {
      BFormInput,
      BButton,
      BFormGroup,
    },
    props: {
      data: {
        type: Object,
      },
    },
    data() {
        return {
            load: false,
            url: "",
            error: false
        };
    },
    directives: {
      Ripple,
    },
    mounted() {
      store.dispatch('vxg_camera/getWebUi', this.data.camera.id)
        .then(response => {
            this.load = true;
            this.url = response.data.proxy_url
        })
        .catch(error => {
          this.error = true;
            console.log(error)
        })
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .page-slot {
    width: 100%;
    height: 100%;
  }
  
  .page-slot-data {
    width: 100%;
    height: 100%;
  }
  
  .frame {
    width: 100%;
    height: 100%;
    border: none;
    overflow: hidden;
  }
  </style>
  